import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { esAltoCilindraje } from '../../../helpers/cilindraje';
import { etiquetasCoberturasResumen } from '../../../helpers/coberturasResumen';
import { getVehicleData } from '../../../helpers/dataLayerHelpers';
import {
  getFromStorage,
  getSessionId,
  removeFromStorage,
  saveToStorage,
} from '../../../helpers/storageUtils';
import {
  aCodigosBackend,
  CoberturaOpcional,
  PERDIDA_PARCIAL,
  PLAN_CON_PERDIDA_PARCIAL,
  tarifaCoberturaOpcional,
} from '../../../Models/coberturaOpcional';
import {
  COMPOSICION_PLAN,
  FRANJA_ALTO_CILINDRAJE,
  GrupoCobertura,
  ItemComposicionPlan,
  NOMBRE_API_PERDIDAS_PARCIALES,
  PRESENTACION_PLANES,
  PresentacionPlan,
  SUBCOBERTURA_EMBEBIDA_RAYONES,
} from '../../../Models/composicionPlan';
import { DatosGenerales } from '../../../Models/datosGenerales';
import { DatosPlanes } from '../../../Models/datosPlanes';
import { Planes, ProductPercentageMap } from '../../../Models/planes';
import { PipesModule } from '../../../pipes/pipes.module';
import { COTIZACION_PAUSA, DATOS_RESTANTES } from '../../../routes.constans';
import { CotizacionService } from '../../../services/Cotizacion/cotizacion.service';
import { DataLayerService } from '../../../services/DataLayer/data-layer.service';
import { ExceptionService } from '../../../services/excepciones/exception.service';
import { LeadsService } from '../../../services/Leads/leads.service';
import { OnerousStateService } from '../../../shared/services/onerous/onerous-state.service';
import { selectData } from '../../../storage/Lead/data.selectors';
import { updateDatosPlanes } from '../../../storage/Planes/planes.action';
import { selectPlanes } from '../../../storage/Planes/planes.selector';

@Component({
  selector: 'app-cards-planes',
  standalone: true,
  imports: [FormsModule, CommonModule, HttpClientModule, ReactiveFormsModule, PipesModule],
  templateUrl: './card-planes.component.html',
  styleUrl: './card-planes.component.scss',
})
export class CardPlanesComponent implements OnInit {
  readonly CONDICIONADO_URL = 'https://www.sura.co/documents/d/seguros/clausulado_motos_digital';
  private onerousStateService = inject(OnerousStateService);

  public planes!: Planes;
  public planesNoIncluye!: Planes;
  public planesTemp: Planes | undefined;
  leadId = '';
  codAsesor = '';
  codigoAsesor: string | undefined;
  valorAntesE = 0;
  valorAntesT = 0;
  valorAntesP = 0;
  datosPlanes: DatosPlanes | null = null;
  datosPlanes$: Observable<DatosPlanes | null>;

  datosGenerales: DatosGenerales | null = null;
  datosGenerales$: Observable<DatosGenerales | null>;

  tipoPagoPlan = '';

  /** Codigo del unico plan que ofrece la cobertura opcional de Perdida Parcial. */
  readonly PLAN_CON_PERDIDA_PARCIAL = PLAN_CON_PERDIDA_PARCIAL;

  readonly FRANJA_ALTO_CILINDRAJE = FRANJA_ALTO_CILINDRAJE;

  /** Estado actual del checkbox de Perdida Parcial. */
  perdidaParcialSeleccionada = false;

  /**
   * Codigos de los planes cuya tarjeta muestra el detalle completo en mobile.
   * En desktop el detalle siempre esta visible: el CSS ignora este estado.
   */
  private planesConDetalleAbierto = new Set<string>();

  /**
   * La moto supera el cilindraje minimo para considerarse de alto cilindraje.
   * Decide la subcobertura Rayones y la franja de asistencias; no interviene
   * en la disponibilidad de Perdida Parcial.
   * Se recalcula cada vez que llegan los datos del lead.
   */
  esAltoCilindraje = false;

  discountPercentagesTable: ProductPercentageMap | undefined;

  datosPlanesEnvio: DatosPlanes = {
    lead_id: '',
    planes: {
      data: {
        products: [
          {
            coveragesGroup: [
              {
                Name: '',
                Include: false,
                Description: '',
              },
            ],
            coverages: [
              {
                price: 0,
                description: '',
                name: '',
              },
            ],
            order: 1,
            code: '',
            priceMensual: {
              currency: '',
              amount: 0,
              formatted: '',
            },
            priceAnual: {
              currency: '',
              amount: 0,
              formatted: '',
            },
            name: '',
          },
        ],
      },
      FalloTarifaEsencialMotos: false,
      FalloTarifaTotalMotos: false,
    },
    payment_frequency: '',
    selected_plan: '',
    coberturasOpcionales: [],
  };
  exceptionsService = inject(ExceptionService);
  leadService = inject(LeadsService);

  constructor(
    private router: Router,
    private store: Store,
    private cotizacionService: CotizacionService,
    private dataLayerService: DataLayerService,
  ) {
    this.datosPlanes$ = this.store.select(selectPlanes);
    this.datosGenerales$ = this.store.select(selectData);

    // Mantenemos los generales del store o también puedes mockearlos si fallan
    this.datosGenerales$ = this.store.select(selectData);
  }

  @Input() tipoPlan = '';
  @Input() sessionId = '';
  ngOnInit(): void {
    this.tipoPagoPlan = this.tipoPlan;
    this.datosGenerales$.subscribe((data) => {
      this.datosGenerales = data;
      this.esAltoCilindraje = esAltoCilindraje(
        this.datosGenerales?.LeadResponse?.data?.vehicle?.cylinder,
      );
    });

    this.datosPlanes$.subscribe((data) => {
      if (data) {
        this.datosPlanesEnvio = data;
        this.perdidaParcialSeleccionada = (data.coberturasOpcionales ?? []).includes(
          PERDIDA_PARCIAL,
        );
      }
      this.planesTemp = data?.planes;
    });
    if (this.planesTemp) {
      for (let i = 0; i < this.planesTemp.data.products.length; i++) {
        if (this.planesTemp.data.products[i].code === 'MOTOS_PlanEsencial') {
          const valorE = this.planesTemp.data.products[i].priceMensual.amount * 0.2;
          this.valorAntesE = this.planesTemp.data.products[i].priceMensual.amount + valorE;
        }
        if (this.planesTemp.data.products[i].code === 'MOTOS_PlanTotal') {
          const valorT = this.planesTemp.data.products[i].priceMensual.amount * 0.2;
          this.valorAntesT = this.planesTemp.data.products[i].priceMensual.amount + valorT;
        }
        if (this.planesTemp.data.products[i].code === 'MOTOS_PlanPremium') {
          const valorP = this.planesTemp.data.products[i].priceMensual.amount * 0.2;
          this.valorAntesP = this.planesTemp.data.products[i].priceMensual.amount + valorP;
        }
      }

      this.discountPercentagesTable = this.planesTemp.data.products.reduce((acc, product) => {
        acc[product.name] = Math.floor(
          100 - (product.priceAnual.amount / product.priceMensual.amount) * 100,
        );
        return acc;
      }, {} as ProductPercentageMap);

      this.planes = this.planesTemp;
      console.log('this.planes', this.planes);
    }
  }

  ResumenPlan(code: number) {
    this.dataLayerService.pushDataLayer({
      event: 'moto_ecommerce_step_3_planes',
      ecom_tipo: 'Moto',
      ecom_item: 'Button',
      ecom_subitem: 'Comprar',
      ecom_pantalla: 'Planes',
      user_id: this.sessionId,
      ...getVehicleData(this.datosGenerales),
      plan_seleccionado: this.planes.data.products[code].name,
    });

    const planCode = this.planes.data.products[code].code;
    const coberturasOpcionales = this.construirCoberturasOpcionales(planCode);

    if (this.datosPlanesEnvio) {
      const datosPlanesEnvioCopia = { ...this.datosPlanesEnvio };
      datosPlanesEnvioCopia.payment_frequency = this.tipoPagoPlan;
      datosPlanesEnvioCopia.selected_plan = planCode;
      datosPlanesEnvioCopia.coberturasOpcionales = coberturasOpcionales;
      this.store.dispatch(updateDatosPlanes({ upDatos: datosPlanesEnvioCopia }));
    }

    if (planCode) {
      const leadId =
        this.datosGenerales?.LeadResponse?.data?.Id ||
        this.datosGenerales?.LeadResponse?.data?.lead_id ||
        '';

      const updateData = {
        selectedPlan: planCode,
        payment_type: this.tipoPagoPlan, // Frecuencia de pago (Annually/Monthly)
        accept_tos: true,
        coberturasOpcionales: aCodigosBackend(coberturasOpcionales),
      };

      this.leadService.UpdateInfoLead(updateData, leadId).subscribe({
        next: () => console.log(`✅ Lead actualizado con selectedPlan: ${planCode}`),
        error: (err) => console.error('❌ Error actualizando lead:', err),
      });
    }

    if (this.validarExcesoPrimaMaximaAlSeleccionar()) {
      return;
    }

    this.handleExceptionLead();
  }

  private handleExceptionLead(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const selection = this.onerousStateService.selection();
    const updateLeadData = getFromStorage<any>('UpdatedLeadData', 'session');
    const leadId = updateLeadData?.lead_id || this.datosGenerales?.LeadResponse?.data?.Id || '';
    const queryParams = this.codigoAsesor ? { codigoAsesor: this.codigoAsesor } : {};

    this.codigoAsesor = urlParams.get('codigoAsesor') || '';
    this.sessionId = getSessionId().toString();

    switch (selection.key) {

      case '000':
        this.router.navigate([DATOS_RESTANTES], { queryParams });
        break;

      case '100':
        saveToStorage('origen_pausa', 'Prenda', 'session');
        this.sendExceptionAndNavigate(leadId, 'Vehículo con prenda', 60);
        break;

      case '010':
        saveToStorage('origen_pausa', 'Accesorios', 'session');
        this.sendExceptionAndNavigate(leadId, 'Vehículo con Accesorios no 0km', 60);
        break;

      case '001':
        this.router.navigate([DATOS_RESTANTES], { queryParams });
        break;

      case '011':
        this.router.navigate([DATOS_RESTANTES], { queryParams });
        break;

      case '101':
        saveToStorage('origen_pausa', '0KMPrenda', 'session');
        this.sendExceptionAndNavigate(leadId, 'Vehículo 0KM con prenda', 60);
        break;

      case '110':
        saveToStorage('origen_pausa', 'PrendaAccesorios', 'session');
        this.sendExceptionAndNavigate(leadId, 'Vehículo con prenda y accesorios', 60);
        break;

      case '111':
        saveToStorage('origen_pausa', 'full', 'session');
        this.sendExceptionAndNavigate(leadId, 'Vehículo 0KM con prenda y accesorios', 60);
        break;

      default:
        this.router.navigate([DATOS_RESTANTES], { queryParams });
        break;
    }
  }

  private sendExceptionAndNavigate(leadId: string, requiredStatus: string, percentage: number): void {
    const queryParams = this.codigoAsesor ? { codigoAsesor: this.codigoAsesor } : {};
    this.exceptionsService
      .addExceptionNew(
        this.sessionId,
        leadId,
        requiredStatus,
        percentage,
        'Habilitado'
      )
      .subscribe({
        next: (response) => {
          if (response?.data?.Success === true) {
            this.router.navigate([COTIZACION_PAUSA], { queryParams });
          } else {
            this.router.navigate([DATOS_RESTANTES], { queryParams });
          }
        },
        error: () => {
          this.router.navigate([DATOS_RESTANTES], { queryParams });
        }
      });
  }

  /**
   * Activa o desactiva la cobertura opcional de Perdida Parcial y persiste el
   * cambio en el store para que la seleccion sobreviva a la navegacion y se
   * mantenga sincronizada entre las vistas Mensual y Anual.
   */
  onTogglePerdidaParcial(seleccionada: boolean): void {
    this.perdidaParcialSeleccionada = seleccionada;

    if (this.datosPlanesEnvio) {
      this.store.dispatch(
        updateDatosPlanes({
          upDatos: {
            ...this.datosPlanesEnvio,
            coberturasOpcionales: seleccionada ? [PERDIDA_PARCIAL] : [],
          },
        }),
      );
    }
  }

  /**
   * Perdida Parcial solo puede viajar cuando el plan seleccionado es Premium,
   * en cualquier cilindraje. Para cualquier otro plan se envia un arreglo
   * vacio, incluso si el store trae una seleccion previa.
   */
  private construirCoberturasOpcionales(planCode: string): CoberturaOpcional[] {
    const aplica = planCode === PLAN_CON_PERDIDA_PARCIAL && this.perdidaParcialSeleccionada;

    return aplica ? [PERDIDA_PARCIAL] : [];
  }

  /** Coberturas que la tarjeta muestra como incluidas en el plan. */
  getIncludes(plan: any) {
    return plan?.coveragesGroup?.filter(
      (coverage: any) => coverage.include === true && !this.esSubcoberturaEmbebida(coverage),
    );
  }

  /** Coberturas que la tarjeta lista bajo "Este plan no incluye". */
  getExcludes(plan: any) {
    return plan?.coveragesGroup?.filter(
      (coverage: any) => coverage.include === false && !this.esSubcoberturaEmbebida(coverage),
    );
  }

  /**
   * Valor que muestra la tarjeta segun la frecuencia de pago, sumando la
   * cobertura opcional cuando esta activa.
   *
   * Ambos precios del backend vienen como total anual, por eso el mensual se
   * divide entre 12 despues de sumar el add-on.
   */
  precioDelPlan(plan: any): number {
    const esMensual = this.tipoPagoPlan === 'Monthly';
    const base = esMensual ? plan?.priceMensual?.amount : plan?.priceAnual?.amount;
    const total = (Number(base) || 0) + this.valorCoberturaOpcional(plan);

    return esMensual ? total / 12 : total;
  }

  /**
   * Prima de la cobertura opcional activa en la frecuencia vigente.
   * Devuelve 0 si el plan no la ofrece, si el interruptor esta apagado o si el
   * backend no envio su tarifa.
   */
  private valorCoberturaOpcional(plan: any): number {
    if (!this.ofreceCoberturaOpcional(plan) || !this.perdidaParcialSeleccionada) {
      return 0;
    }

    const tarifa = tarifaCoberturaOpcional(plan?.coberturasOpcionales, PERDIDA_PARCIAL);
    const precio = this.tipoPagoPlan === 'Monthly' ? tarifa?.priceMensual : tarifa?.priceAnual;

    return Number(precio?.amount) || 0;
  }

  /** Distintivo, descripcion y franja que corresponden al plan. */
  presentacionDe(plan: any): PresentacionPlan | undefined {
    return PRESENTACION_PLANES[plan?.code];
  }

  /**
   * Items que la tarjeta lista bajo "Este plan no incluye".
   *
   * El orden lo fija `ordenExcluido` del catalogo, no el campo `order` del
   * backend: ese llega distinto segun el plan para la misma cobertura.
   */
  exclusionesDelPlan(plan: any): ItemComposicionPlan[] {
    const excluidas: any[] = this.getExcludes(plan) ?? [];

    return excluidas
      .filter((cobertura) => !this.esPerdidasParcialesOfrecida(plan, cobertura))
      .map((cobertura) => this.aItemDeComposicion(cobertura))
      .sort((a, b) => this.ordenExcluidoDe(a) - this.ordenExcluidoDe(b));
  }

  /**
   * El plan ofrece el interruptor de Perdidas parciales. Es la misma condicion
   * que gobierna el bloque "Cobertura opcional" de la tarjeta.
   * Aplica a Premium en cualquier cilindraje.
   */
  ofreceCoberturaOpcional(plan: any): boolean {
    return plan?.code === PLAN_CON_PERDIDA_PARCIAL;
  }

  /**
   * Perdidas parciales no se lista como no incluida cuando el propio plan
   * ofrece activarla con el interruptor: seria contradictorio.
   */
  private esPerdidasParcialesOfrecida(plan: any, cobertura: any): boolean {
    return (
      this.ofreceCoberturaOpcional(plan) &&
      this.nombreDe(cobertura) === this.normalizar(NOMBRE_API_PERDIDAS_PARCIALES)
    );
  }

  /**
   * Traduce una cobertura del backend al texto del diseno. Si el nombre no esta
   * en el catalogo se usa el que venga del backend, para no perder el item.
   */
  private aItemDeComposicion(cobertura: any): ItemComposicionPlan {
    const nombre = this.nombreDe(cobertura);
    const item = COMPOSICION_PLAN.find((it) => this.normalizar(it.nombreApi) === nombre);

    if (!item) {
      return {
        nombreApi: String(cobertura?.name ?? cobertura?.Name ?? ''),
        grupo: 'cobertura' as GrupoCobertura,
        texto: String(cobertura?.name ?? cobertura?.Name ?? ''),
      };
    }

    const conCilindraje = this.aplicarVarianteCilindraje(item);

    if (!conCilindraje.textoExcluido) {
      return conCilindraje;
    }

    return { ...conCilindraje, texto: conCilindraje.textoExcluido, destacado: undefined };
  }

  /**
   * Algunas coberturas cambian de texto segun el cilindraje. Es el caso de
   * Pequenos Eventos, cuyas subcoberturas incluyen Rayones solo en alto
   * cilindraje.
   */
  private aplicarVarianteCilindraje(item: ItemComposicionPlan): ItemComposicionPlan {
    if (!this.esAltoCilindraje || !item.textoAltoCilindraje) {
      return item;
    }

    return {
      ...item,
      texto: item.textoAltoCilindraje,
      destacado: item.destacadoAltoCilindraje ?? item.destacado,
    };
  }

  private ordenExcluidoDe(item: ItemComposicionPlan): number {
    return item.ordenExcluido ?? Number.MAX_SAFE_INTEGER;
  }

  /**
   * Rayones no se pinta como item propio: viaja dentro del texto de Danos
   * menores cuando la moto es de alto cilindraje.
   */
  private esSubcoberturaEmbebida(cobertura: any): boolean {
    return this.nombreDe(cobertura) === this.normalizar(SUBCOBERTURA_EMBEBIDA_RAYONES);
  }

  /**
   * Coberturas y asistencias incluidas, con el texto corto, para la vista
   * resumida de la tarjeta en mobile. Mismo catalogo y orden que el detalle.
   */
  resumenDelPlan(plan: any): string[] {
    return etiquetasCoberturasResumen(plan?.coveragesGroup, this.esAltoCilindraje);
  }

  detalleAbierto(plan: any): boolean {
    return this.planesConDetalleAbierto.has(plan?.code);
  }

  /** Alterna entre la vista resumida y el detalle completo (solo mobile). */
  alternarDetalle(plan: any): void {
    if (this.detalleAbierto(plan)) {
      this.planesConDetalleAbierto.delete(plan?.code);
    } else {
      this.planesConDetalleAbierto.add(plan?.code);
    }
  }

  /** Items que la tarjeta pinta bajo el titulo "Coberturas". */
  coberturasDelPlan(plan: any): ItemComposicionPlan[] {
    return this.componerGrupo(plan, 'cobertura');
  }

  /** Items que la tarjeta pinta bajo el titulo "Asistencias". */
  asistenciasDelPlan(plan: any): ItemComposicionPlan[] {
    return this.componerGrupo(plan, 'asistencia');
  }

  /**
   * Cruza las coberturas incluidas que devuelve el backend contra el catalogo
   * de composicion, y las entrega en el orden del catalogo.
   *
   * Una cobertura que el backend incluya pero que no este en el catalogo se
   * pinta igual, al final del grupo "cobertura" y con su texto crudo, para no
   * perder informacion en silencio si backend agrega nombres nuevos.
   */
  private componerGrupo(plan: any, grupo: GrupoCobertura): ItemComposicionPlan[] {
    const incluidas: any[] = this.getIncludes(plan) ?? [];
    const nombresIncluidos = incluidas.map((cobertura) => this.nombreDe(cobertura));

    const delCatalogo = COMPOSICION_PLAN.filter(
      (item) => item.grupo === grupo && nombresIncluidos.includes(this.normalizar(item.nombreApi)),
    ).map((item) => this.aplicarVarianteCilindraje(item));

    if (grupo !== 'cobertura') {
      return delCatalogo;
    }

    const nombresDelCatalogo = COMPOSICION_PLAN.map((item) => this.normalizar(item.nombreApi));
    const sinCatalogar: ItemComposicionPlan[] = incluidas
      .filter((cobertura) => !nombresDelCatalogo.includes(this.nombreDe(cobertura)))
      .map((cobertura) => ({
        nombreApi: String(cobertura?.name ?? cobertura?.Name ?? ''),
        grupo: 'cobertura' as GrupoCobertura,
        texto: String(cobertura?.name ?? cobertura?.Name ?? ''),
      }));

    return [...delCatalogo, ...sinCatalogar];
  }

  private nombreDe(cobertura: any): string {
    return this.normalizar(String(cobertura?.name ?? cobertura?.Name ?? ''));
  }

  private normalizar(valor: string): string {
    return valor.trim().toLowerCase();
  }

  getOriginalPrice(discountedPrice: number, discountRate: number) {
    // Calculate original price
    const originalPrice = discountedPrice / (1 - discountRate);
    return originalPrice;
  }

  openCondicionado() {
    window.open(this.CONDICIONADO_URL, '_blank');
  }

  private validarExcesoPrimaMaximaAlSeleccionar(): boolean {
    // Obtener los datos de planes del storage que contienen los campos de validación
    const planesData = getFromStorage<any>('validPlans', 'session');
    const leadId = getFromStorage<any>('LeadId', 'session');
    const urlParams = new URLSearchParams(window.location.search);
    this.codigoAsesor = urlParams.get('codigoAsesor') || '';
    this.sessionId = getSessionId().toString();

    if (!planesData || planesData.length === 0) {
      //this.logger.warn('No se encontraron datos de planes en el storage');
      return false;
    }

    // Verificar si alguno de los planes excede la prima máxima según el tipo de pago actual
    let excedePrimaMaxima = false;
    let tipoPagoExcedido = '';

    for (const planData of planesData) {
      if (this.tipoPagoPlan === 'Monthly' && planData.ExcedePrimaMaximaMensual) {
        excedePrimaMaxima = true;
        tipoPagoExcedido = 'mensual';
        break;
      } else if (this.tipoPagoPlan === 'Annually' && planData.ExcedePrimaMaximaAnual) {
        excedePrimaMaxima = true;
        tipoPagoExcedido = 'anual';
        break;
      }
    }

    if (excedePrimaMaxima) {
      // Limpiar origen de pausa previo
      removeFromStorage('origen_pausa', 'session');
      saveToStorage('origen_pausa', `excede_prima_${tipoPagoExcedido}`, 'session');

      const ExceptionData = {
        required_status: '',
        percentege_lead: 0,
      };

      ExceptionData.percentege_lead = 60;
      ExceptionData.required_status = 'Valor máximo prima';

      // Enviar la excepción general
      this.exceptionsService
        .addExceptionNew(
          this.sessionId,
          leadId || '',
          ExceptionData.required_status,
          ExceptionData.percentege_lead,
          'Habilitado',
        )
        .subscribe((response) => {
          if (response.data.Success === true) {
            this.codigoAsesor
              ? this.router.navigate([COTIZACION_PAUSA], {
                queryParams: { codigoAsesor: this.codigoAsesor },
              })
              : this.router.navigate([COTIZACION_PAUSA]);
          }
        });

      return true;
    }

    return false;
  }
}
